import { PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { call, put } from "redux-saga/effects";
import { Money } from "../../../../services/reddyApi/Money/Money";
import handleServerError from "../../all/saga/handleServerError";
import setServerErrorDefault from "../../all/saga/setServerErrorDefault";
import { searchCounteragentsAsClientsFetch, searchCounteragentsAsClientSuccess } from "../finance.slice";
import { SearchCounteragentsPayload } from "../payload/SearchCounteragents/SearchCounteragentsPayload";

function* searchCounteragentsAsClientsWorker(action: PayloadAction<SearchCounteragentsPayload>) {
    const { vendorId, value } = action.payload;
    const dataParams = {
        vendorId,
        value
    }

    try {
        const { data } = yield call(Money.searchCounteragentsAsClients, dataParams);

        yield put(searchCounteragentsAsClientSuccess(data));

        yield setServerErrorDefault();
    } catch (error) {
        if (axios.isAxiosError(error)) {
            const actionCreator = () => searchCounteragentsAsClientsFetch(action.payload);

            yield handleServerError(error, actionCreator);
        }
    }
}

export default searchCounteragentsAsClientsWorker;